// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_eM","advertDetailContacts__header":"c-n_eN"};